
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/editApptCalendarEvent';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<input type=\"number\" name=\"max_participants\" class=\"max-participants\" min=\"1\" disabled=\"\">", options) : helperMissing.call(depth0, "__i18nliner_safe", "<input type=\"number\" name=\"max_participants\" class=\"max-participants\" min=\"1\" disabled=\"\">", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'input_type_number_name_max_parti': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.edit_appt_calendar_event")
  },data:data},helper ? helper.call(depth0, "limit_this_slot_to_input_type_number_name_max_part_1580add0", "Limit this slot to %{input_type_number_name_max_parti} groups.", options) : helperMissing.call(depth0, "t", "limit_this_slot_to_input_type_number_name_max_part_1580add0", "Limit this slot to %{input_type_number_name_max_parti} groups.", options)))
    + "\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.__i18nliner_safe || (depth0 && depth0.__i18nliner_safe),options={hash:{},data:data},helper ? helper.call(depth0, "<input type=\"number\" name=\"max_participants\" class=\"max-participants\" min=\"1\" disabled=\"\">", options) : helperMissing.call(depth0, "__i18nliner_safe", "<input type=\"number\" name=\"max_participants\" class=\"max-participants\" min=\"1\" disabled=\"\">", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'input_type_number_name_max_parti': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.edit_appt_calendar_event")
  },data:data},helper ? helper.call(depth0, "limit_this_slot_to_input_type_number_name_max_part_8344547a", "Limit this slot to %{input_type_number_name_max_parti} users.", options) : helperMissing.call(depth0, "t", "limit_this_slot_to_input_type_number_name_max_part_8344547a", "Limit this slot to %{input_type_number_name_max_parti} users.", options)))
    + "\n    ";
  return buffer;
  }

  buffer += "<form action=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.calendarEvent)),stack1 == null || stack1 === false ? stack1 : stack1.appointment_group_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" id=\"edit_appt_calendar_event_form\">\n  <p>\n    <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.edit_appt_calendar_event")
  },data:data},helper ? helper.call(depth0, "calendar.edit_appt_calendar_event.description", "Description:", options) : helperMissing.call(depth0, "t", "calendar.edit_appt_calendar_event.description", "Description:", options)))
    + "</strong><br>\n    <textarea name=\"description\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n  </p>\n  <p>\n   <label id=\"max_participants_container\">\n    "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ((depth0 && depth0.null))
  },data:data},helper ? helper.call(depth0, "max_participants_option", options) : helperMissing.call(depth0, "checkbox", "max_participants_option", options)))
    + "\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.calendarEvent)),stack1 == null || stack1 === false ? stack1 : stack1.participant_type), "Group", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.calendarEvent)),stack1 == null || stack1 === false ? stack1 : stack1.participant_type), "Group", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n   </label>\n  </p>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  